import Hierahome1 from '../../Media/homeimages/Wynyard 9.webp'
import Hierahome2 from '../../Media/homeimages/Wynyard 9.webp'





const Hierahomeimages =[
Hierahome1,Hierahome2
]

export default Hierahomeimages;